import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDocumentByEmployee } from "src/models/HumanResources/DocumentsByEmployee.models";
import { IInfoEmployee } from "src/models/HumanResources/InfoEmployees.models";

interface InfoEmployeeState {
  infoEmployees: IInfoEmployee[];
  infoEmployeeToEdit: IInfoEmployee | null;
}

const initialState: InfoEmployeeState = {
  infoEmployees: [],
  infoEmployeeToEdit: null,
};

const InfoEmployeeSlice = createSlice({
  name: "InfoEmployee",
  initialState,
  reducers: {
    setInfoEmployeeList: (state, action: PayloadAction<IInfoEmployee[]>) => {
      state.infoEmployees = action.payload;
    },
    concatListInfoEmployee: (
      state: InfoEmployeeState,
      action: PayloadAction<IInfoEmployee[]>
    ) => {
      state.infoEmployees = [...state.infoEmployees.concat(action.payload)];
    },
    setInfoEmployeeToEdit: (
      state,
      action: PayloadAction<IInfoEmployee | null>
    ) => {
      state.infoEmployeeToEdit = action.payload;
    },
    addInfoEmployee: (state, action: PayloadAction<IInfoEmployee>) => {
      state.infoEmployees.push(action.payload);
    },
    updateInfoEmployee: (state, action: PayloadAction<IInfoEmployee>) => {
      let itemIndex = state.infoEmployees.findIndex(
        item => item.infoEmployeeId === action.payload.infoEmployeeId
      );
      if (itemIndex !== -1) state.infoEmployees[itemIndex] = action.payload;
    },
    deleteInfoEmployee: (state, action: PayloadAction<number>) => {
      const newArray = state.infoEmployees.filter(
        item => item.infoEmployeeId !== action.payload
      );
      state.infoEmployees = newArray;
    },
    addOrUpdateDocumentByEmployee: (
      state,
      action: PayloadAction<{
        infoEmployeeId: number;
        document: IDocumentByEmployee | null;
      }>
    ) => {
      const { infoEmployeeId, document } = action.payload;
      const employee = state.infoEmployees.find(
        employee => employee.infoEmployeeId === infoEmployeeId
      );
      if (employee) {
        //employee.documentsByEmployee.push(document);
        const existingDocumentIndex = employee.documentsByEmployee
          ? employee.documentsByEmployee.findIndex(
              doc =>
                doc.documentNumber === document?.documentNumber &&
                doc.documentTypeId === document?.documentTypeId
            )
          : -1;

        if (document) {
          if (existingDocumentIndex !== -1) {
            // Si el documento ya existe, actualiza su información
            employee.documentsByEmployee[existingDocumentIndex] = document;
          } else {
            // Si el documento no existe, agrégalo al arreglo
            if (!employee.documentsByEmployee)
              employee.documentsByEmployee = [];

            employee.documentsByEmployee.push(document);
          }
        }
      }
    },
  },
});

export const {
  setInfoEmployeeList,
  concatListInfoEmployee,
  setInfoEmployeeToEdit,
  addInfoEmployee,
  updateInfoEmployee,
  deleteInfoEmployee,
  addOrUpdateDocumentByEmployee,
} = InfoEmployeeSlice.actions;

export default InfoEmployeeSlice.reducer;
